module.exports = __webpack_public_path__ + "img/russia-flag.4b78c77.png";